<template>
    <div class="my-3">
        <h4 class="mb-3">
            <span class="text-muted">Prospetto Costi Carriera</span>
        </h4>
        <div class="bg-white border rounded small p-4">
            <div class="row">
                <div class="col-4">
                    <div class="pr-2">
                        <p><strong>COSTI AGGIUNTIVI</strong></p>
                        <div class="border rounded p-3">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" checked disabled>
                                <label class="form-check-label" for="checkDefault">
                                    Contributo Servizi agli Studenti (€ 300 annuali)
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" checked disabled> 
                                <label class="form-check-label" for="checkChecked">
                                    Ammissione Prova Finale Laurea (€ 360 una tantum)
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" :value="1" v-model="sede">
                                <label class="form-check-label" for="checkChecked">
                                    Sblocco Calendario/Sede esterna (€ 175 annuali cadauna)
                                </label>
                                <div class="d-flex my-2 align-items-center" v-if="sede">
                                    <div class="me-2">N° sedi annuali</div>
                                    <div class="w-25">
                                        <input type="number" class="form-control form-control-sm" value="1" min="1" v-model="n_sedi">
                                    </div>
                                </div>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" :value="1" v-model="pergamena">
                                <label class="form-check-label" for="checkChecked">
                                    Pergamena di laurea (€ 250 una tantum)
                                </label>
                            </div>
                        </div>
                        <!-- Anno di Iscrizione -->
                        <div class="row my-3" v-if="form && form.course">
                            <label for="aa" class="col-12 col-form-label fw-bold">ANNO DI ISCRIZIONE AL CORSO:</label>
                            <div class="col-12">
                                <select class="form-select" v-model="enrol_year" required>
                                    <option :value="0" disabled>Seleziona...</option>
                                    <option v-for="n in form.course.duration" :key="n" :value="n">
                                        {{ n }}° anno
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-8" v-if="form && form.prospect">
                    <p><strong>COMPARAZIONE</strong></p>
                    <table class="table table-bordered text-secondary mb-0 table-general">
                        <thead>
                            <tr class="border-bottom">
                                <th class="bg-light">Voce di Costo</th>
                                <th class="text-center bg-light" :class="{ 'border-top-pricing': isBase }">Base</th>
                                <th class="text-center bg-light" :class="{ 'border-top-pricing': isFA }">Full Access</th>
                                <th class="text-center bg-light" :class="{ 'border-top-pricing': isFAP }">Full Access Plus</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Retta 1° anno</td>
                                <td class="text-center" :class="{ 'border-x-pricing': isBase }">
                                    € {{ $formattaNumeroItaliano(form.imports['BASE']['FIRST_YEAR']['import'], 0) }}
                                </td>
                                <td class="text-center" :class="{ 'border-x-pricing': isFA }">
                                    € {{ $formattaNumeroItaliano(form.imports['FULL_ACCESS']['FIRST_YEAR']['import'], 0) }}
                                </td>
                                <td class="text-center" :class="{ 'border-x-pricing': isFAP }">
                                    € {{ $formattaNumeroItaliano(form.imports['FULL_ACCESS_PLUS']['FIRST_YEAR']['import'], 0) }}
                                </td>
                            </tr>
                            <tr v-for="y in years" :key="y">
                                <td>Retta {{ y+1 }}° anno</td>
                                <td class="text-center" :class="{ 'border-x-pricing': isBase }">
                                    € {{ $formattaNumeroItaliano(form.imports['BASE']['OTHER_YEARS']['import'], 0) }}
                                </td>
                                <td class="text-center" :class="{ 'border-x-pricing': isFA }">
                                    € {{ $formattaNumeroItaliano(form.imports['FULL_ACCESS']['OTHER_YEARS']['import'], 0) }}
                                </td>
                                <td class="text-center" :class="{ 'border-x-pricing': isFAP }">
                                    € {{ $formattaNumeroItaliano(form.imports['FULL_ACCESS_PLUS']['OTHER_YEARS']['import'], 0) }}
                                </td>
                            </tr>
                            <tr>
                                <td>Contributo Servizi agli Studenti</td>
                                <td class="text-center" :class="{ 'border-x-pricing': isBase }">
                                    € {{ $formattaNumeroItaliano(300 * (years+1), 0) }} (€ 300 x {{ years+1 }} anni)
                                </td>
                                <td class="text-center" :class="{ 'border-x-pricing': isFA }">
                                    € {{ $formattaNumeroItaliano(300 * (years+1), 0) }} (€ 300 x {{ years+1 }} anni)
                                </td>
                                <td class="text-center" :class="{ 'border-x-pricing': isFAP }">
                                    € {{ $formattaNumeroItaliano(300 * (years+1), 0) }} (€ 300 x {{ years+1 }} anni)
                                </td>
                            </tr>
                            <tr>
                                <td>Ammissione Prova Finale Laurea</td>
                                <td class="text-center" :class="{ 'border-x-pricing': isBase }">
                                    € {{ $formattaNumeroItaliano(360, 0) }} (una tantum)
                                </td>
                                <td class="text-center" :class="{ 'border-x-pricing': isFA }">
                                    € {{ $formattaNumeroItaliano(360, 0) }} (una tantum)
                                </td>
                                <td class="text-center" :class="{ 'border-x-pricing': isFAP }">
                                    € {{ $formattaNumeroItaliano(360, 0) }} (una tantum)
                                </td>
                            </tr>
                            <tr>
                                <td>Pergamena di laurea</td>
                                <td class="text-center" :class="{ 'border-x-pricing': isBase }">
                                    {{ pergamena ? '€ 250 (una tantum)' : 'Non inclusa' }}
                                </td>
                                <td class="text-center" :class="{ 'border-x-pricing': isFA }">
                                    {{ pergamena ? '€ 250 (una tantum)' : 'Non inclusa' }}
                                </td>
                                <td class="text-center" :class="{ 'border-x-pricing': isFAP }">
                                    {{ pergamena ? '€ 250 (una tantum)' : 'Non inclusa' }}
                                </td>
                            </tr>
                            <tr>
                                <td>Calendari/Sedi</td>
                                <td class="text-center" :class="{ 'border-x-pricing': isBase }">
                                    {{ sede ? '€ ' + $formattaNumeroItaliano((n_sedi * 175 * (years+1)), 0) +  ' (€ ' + $formattaNumeroItaliano((n_sedi * 175), 0)  + ' x ' + (years + 1) + ' anni)' : 'Non inclusi' }}
                                </td>
                                <td class="text-center" :class="{ 'border-x-pricing': isFA }">Inclusi</td>
                                <td class="text-center" :class="{ 'border-x-pricing': isFAP }">Inclusi</td>
                            </tr>
                            <tr v-if="isMCard">
                                <td>Multiversity Card</td>
                                <td class="text-center" :class="{ 'border-x-pricing': isBase }">
                                    € {{ $formattaNumeroItaliano(50 * (years+1), 0) }} (€ 50 x {{ years+1 }} anni)
                                </td>
                                <td class="text-center" :class="{ 'border-x-pricing': isFA }">
                                    € {{ $formattaNumeroItaliano(50 * (years+1), 0) }} (€ 50 x {{ years+1 }} anni)
                                </td>
                                <td class="text-center" :class="{ 'border-x-pricing': isFAP }">
                                    € {{ $formattaNumeroItaliano(50 * (years+1), 0) }} (€ 50 x {{ years+1 }} anni)
                                </td>
                            </tr>
                            <tr class="border-bottom" v-if="years > 0">
                                <th class="bg-light">Stima 1° anno *</th>
                                <th class="text-center bg-light" :class="{ 'border-x-pricing': isBase }">
                                    € {{ 
                                        $formattaNumeroItaliano(
                                            form.imports['BASE']['FIRST_YEAR']['import'] + 
                                            300 + 
                                            (sede ? n_sedi * 175 : 0) +
                                            (isMCard ? 50 : 0),
                                            0
                                        ) 
                                    }}
                                </th>
                                <th class="text-center bg-light" :class="{ 'border-x-pricing': isFA }">
                                    € {{ 
                                        $formattaNumeroItaliano(form.imports['FULL_ACCESS']['FIRST_YEAR']['import'] + 300 + (isMCard ? 50 : 0), 0) 
                                    }}
                                </th>
                                <th class="text-center bg-light" :class="{ 'border-x-pricing': isFAP }">
                                    € {{ 
                                        $formattaNumeroItaliano(form.imports['FULL_ACCESS_PLUS']['FIRST_YEAR']['import'] + 300 + (isMCard ? 50 : 0), 0) 
                                    }}
                                </th>
                            </tr>
                            <tr class="border-bottom" v-for="y in years" :key="y">
                                <th class="bg-light">Stima {{ y+1 }}° anno *</th>
                                <th class="text-center bg-light" :class="{ 'border-x-pricing': isBase }">
                                    <span v-if="y != years">
                                        € {{ $formattaNumeroItaliano(form.imports['BASE']['OTHER_YEARS']['import'] + 300 + (sede ? n_sedi * 175 : 0) + (isMCard ? 50 : 0), 0) }}
                                    </span>
                                    <span v-else>
                                        € {{ $formattaNumeroItaliano(form.imports['BASE']['OTHER_YEARS']['import'] + 300 + (sede ? n_sedi * 175 : 0) + (pergamena ? 250 : 0) + 360 + (isMCard ? 50 : 0), 0) }}
                                    </span>
                                </th>
                                <th class="text-center bg-light" :class="{ 'border-x-pricing': isFA }">
                                    <span v-if="y != years">
                                        € {{ $formattaNumeroItaliano(form.imports['FULL_ACCESS']['OTHER_YEARS']['import'] + 300 + (isMCard ? 50 : 0), 0) }}
                                    </span>
                                    <span v-else>
                                        € {{ $formattaNumeroItaliano(form.imports['FULL_ACCESS']['OTHER_YEARS']['import'] + 300 + (pergamena ? 250 : 0) + 360 + (isMCard ? 50 : 0), 0) }}
                                    </span>
                                </th>
                                <th class="text-center bg-light" :class="{ 'border-x-pricing': isFAP }">
                                    <span v-if="y != years">
                                        € {{ $formattaNumeroItaliano(form.imports['FULL_ACCESS_PLUS']['OTHER_YEARS']['import'] + 300 + (isMCard ? 50 : 0), 0) }}
                                    </span>
                                    <span v-else>
                                        € {{ $formattaNumeroItaliano(form.imports['FULL_ACCESS_PLUS']['OTHER_YEARS']['import'] + 300 + (pergamena ? 250 : 0) + 360 + (isMCard ? 50 : 0), 0) }}
                                    </span>
                                </th>
                            </tr>
                            <tr class="border-bottom">
                                <th class="bg-light">Stima costo totale *</th>
                                <th class="text-center bg-light" :class="{ 'border-bottom-pricing': isBase }">
                                    € {{ 
                                        $formattaNumeroItaliano(
                                            form.imports['BASE']['FIRST_YEAR']['import'] + 
                                            (form.imports['BASE']['OTHER_YEARS']['import'] * years) +
                                            (300 * (years+1)) +  
                                            (sede ? (n_sedi * 175) * (years+1) : 0) +
                                            360 + 
                                            (pergamena ? 250 : 0) +
                                            (isMCard ? 50 * (years+1) : 0)
                                        , 0)
                                    }}
                                </th>
                                <th class="text-center bg-light" :class="{ 'border-bottom-pricing': isFA }">
                                    € {{ 
                                        $formattaNumeroItaliano(
                                            form.imports['FULL_ACCESS']['FIRST_YEAR']['import'] + 
                                            (form.imports['FULL_ACCESS']['OTHER_YEARS']['import'] * years) +
                                            (300 * (years+1)) +  
                                            360 + 
                                            (pergamena ? 250 : 0) +
                                            (isMCard ? 50 * (years+1) : 0)
                                        , 0)
                                    }}
                                </th>
                                <th class="text-center bg-light" :class="{ 'border-bottom-pricing': isFAP }">
                                    € {{ 
                                        $formattaNumeroItaliano(
                                            form.imports['FULL_ACCESS_PLUS']['FIRST_YEAR']['import'] + 
                                            (form.imports['FULL_ACCESS_PLUS']['OTHER_YEARS']['import'] * years) +
                                            (300 * (years+1)) +  
                                            360 + 
                                            (pergamena ? 250 : 0) +
                                            (isMCard ? 50 * (years+1) : 0)
                                        , 0)
                                    }}
                                </th>
                            </tr>
                        </tbody>
                    </table>
                    <p class="my-2 small text-muted">
                        * Si aggiungono i costi annuali della Tassa Regionale da pagare direttamente all'ente regionale.
                    </p>
                    <div class="col-6 mt-3">
                        <div class="input-group">
                            <input 
                                type="text" 
                                class="form-control" 
                                placeholder="Nome prospetto (facoltativo)" 
                                aria-label="Nome prospetto (facoltativo)" 
                                aria-describedby="button-addon2"
                                v-model="name">
                            <button class="btn btn-primary" @click="generatePdf" :disabled="!form || !form.program || !form.installments">Genera PDF</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
    import { jsPDF } from "jspdf"
    import autoTable from 'jspdf-autotable';

    export default {
        data() {
            return {
                sede: 0,
                n_sedi: 1,
                pergamena: 0,
                certificato: 0,
                n_certificati: 1,
                study: 0,
                enrol_year: 1,
                name: null
            }
        },
        computed: {
            years () {
                const enrol_year = this.enrol_year
                const course = this.$store.getters['summary/course']
                if (enrol_year && course && course.duration) {
                    return (course.duration - enrol_year)
                } else {
                    return 1
                }
            },
            sedi () {
                if (this.sede && this.n_sedi && this.years) {
                    return this.n_sedi * 175 * this.years
                } else {
                    return 'Non incluso'
                }
            },
            form () {
                return this.$store.getters['summary/form']
            },
            isMCard() {
                return this.form && this.form.convention && this.form.convention.label.includes('MULTIVERSITY CARD')
            },
            isBase() {
                return this.form && this.form.program && this.form.program.label == 'BASE 26_27'
            },
            isFA() {
                return this.form && this.form.program && this.form.program.label == 'FULL ACCESS 26_27'
            },
            isFAP() {
                return this.form && this.form.program && this.form.program.label == 'FULL ACCESS PLUS 26_27'
            },
        },
        methods: {
            generatePdf() {
                const doc = new jsPDF();

                // 1. Titolo
                doc.setFontSize(18);
                doc.setTextColor(0);
                doc.text("Riepilogo Costi Retta Universitaria", 14, 15);

                // 2. Riepilogo Selezioni
                doc.setFontSize(14);
                doc.setTextColor(0);
                doc.text("Riepilogo Selezioni", 14, 32);
                doc.setFontSize(10);
                doc.setTextColor(100);

                let y = 40;
                const addLine = (label, value) => {
                    if (value && value !== "Seleziona") {
                        doc.text(`${label}:`, 14, y, { fontStyle: "bold" });
                        doc.text(value, 60, y);
                        y += 7;
                    }
                };

                let at = {
                    'PEGASO': 'Università Telematica Pegaso',
                    'MERCATORUM': 'Universitas Mercatorum',
                    'SANRAFFAELE': 'Università Telematica San Raffaele Roma'
                }
                const form = this.form
                if (this.name) {
                    addLine('Nome prospetto', this.name)
                }
                addLine('Università', at[form.from])
                addLine('Corso di laurea', form.course.name)
                addLine('Anno Accademico', form.aa)
                addLine('Piano di studi', form.pds.label)
                addLine('Agevolazione', form.convention.label)
                if (form.company) {
                    addLine('Enti/Aziende', form.company.label)
                }
                addLine('Programma', form.program.label)
                addLine('Rate', form.installments.label + ' rate')
                addLine('Programma formativo', form.label)
                addLine('Codice Promo', form.promo_code)

                y += 5;

                // 3. Prospetti Annuali
                const prospettiTables = document.querySelectorAll(".table-rate");
                prospettiTables.forEach((table, index) => {
                    let title
                    if (index == 0) {
                        title = 'Prospetto rate e importi '+ (index + 1) +'° anno'
                    } else {
                        title = 'Prospetto rate e importi anni successivi'
                    }
                    
                    doc.setFontSize(14);
                    doc.setTextColor(0);
                    doc.text(title, 14, y);
                    y += 8;
                    autoTable(doc, {
                        html: table,
                        startY: y,
                        theme: "grid",
                        headStyles: { fillColor: [233, 236, 239], textColor: 0, fontStyle: "bold" },
                        didParseCell: function (data) {
                            if (data.row.section === "body" && data.column.index === 1) {
                                data.cell.styles.fontStyle = "bold";
                                data.cell.styles.fontSize = 12;
                            }
                            const bodyRowCount = data.table.body.length;
                            const currentRowIndex = data.row.index;
                            if (data.row.section === "body" && currentRowIndex >= bodyRowCount - 1) {
                                // Applica stile header
                                data.cell.styles.fillColor = [233, 236, 239];
                                data.cell.styles.textColor = 0;
                                data.cell.styles.fontStyle = "bold";
                            }
                        }
                    });
                    y = doc.lastAutoTable.finalY + 5;
                    if (form.program.label == 'BASE' || form.program.label.includes('26_27')) {
                        doc.setFontSize(8);
                        doc.setTextColor(100);
                        doc.text('Ad ogni rata va aggiunto il Contributo per i Servizi agli Studenti di € ' + (300 / form.installments.label) + '.', 14, y);
                        y+=5
                    }
                    if (this.isMCard) {
                        doc.setFontSize(8);
                        doc.setTextColor(100);
                        doc.text('Al primo pagamento va aggiunto il costo della Multiversity Card di € 50.', 14, y);
                        y+=5
                    }
                    if (index == 0) {
                        y+=10
                    }
                });

                doc.addPage();
                y = 15;

                doc.setFontSize(14);
                doc.setTextColor(0);
                doc.text("Riepilogo Costi Aggiuntivi", 14, y);
                y += 10;
                doc.setFontSize(10);
                doc.setTextColor(100);

                const addExtraCostLine = (label, value) => {
                    doc.text(`${label}:`, 14, y, { fontStyle: "bold" });
                    doc.text(value, 110, y);
                    y += 7;
                };
                
                let tax = form.program.label == 'ALL INCLUSIVE' ? "Inclusa" : "Sì"
                let prov = form.program.label == 'ALL INCLUSIVE' ? "Inclusa" : "Sì"
                let sedi = form.program.label.includes('ALL INCLUSIVE') || form.program.label.includes('FULL ACCESS') ? "Inclusa" : this.sede == 1 ? `Sì (N. sedi: ${this.n_sedi})` : "No"
                let cert = 'No'
                if (form.program.label == 'ALL INCLUSIVE' || (this.certificato && this.n_certificati > 0)) {
                    cert = 'Sì (N. certificati: ' + this.n_certificati + ')'
                }
                let perg = this.pergamena == 1 ? 'Sì' : 'Non inclusa'
                addExtraCostLine("Contributo Servizi agli Studenti (€ 300 annuali)", tax);              
                addExtraCostLine("Ammissione Prova Finale Laurea (€ 360 una tantum)", prov);
                addExtraCostLine("Sede Esterna (€ 175 annuali cadauna)", sedi);
                addExtraCostLine("Pergamena di laurea (€ 250 una tantum)", perg);
                if (this.isMCard) {
                    addExtraCostLine("Multiversity Card (€ 50 annuali)", "Sì");
                }
            
                y += 5;

                const generalTable = document.querySelectorAll(".table-general");
                generalTable.forEach((table, index) => {
                    let title;
                    title = 'COMPARAZIONE *'
                    doc.setFontSize(14);
                    doc.setTextColor(0);
                    doc.text(title, 14, y);
                    y += 8;
                    autoTable(doc, {
                        html: table,
                        startY: y,
                        theme: "grid",
                        headStyles: { fillColor: [233, 236, 239], textColor: 0, fontStyle: "bold" },
                        didParseCell: function (data) {
                            const bodyRowCount = data.table.body.length;
                            const currentRowIndex = data.row.index;
                            if (data.row.section === "body") {
                                // Controlla se ALMENO UNA cella di questa riga contiene la parola "Stima"
                                const rigaContieneStima = Object.values(data.row.cells).some(cell => {
                                    return cell.text && cell.text[0] && cell.text[0].includes('Stima');
                                });
                                // Se la riga contiene "Stima", applica lo stile a TUTTE le sue celle
                                if (rigaContieneStima) {
                                    data.cell.styles.fillColor = [233, 236, 239];
                                    data.cell.styles.textColor = 0;
                                    data.cell.styles.fontStyle = "bold";
                                }
                            }
                        }
                    });
                    y = doc.lastAutoTable.finalY + 5;
                    doc.setFontSize(8);
                    doc.setTextColor(100);
                    doc.text('* Si aggiungono i costi annuali della Tassa Regionale da pagare direttamente all\'ente regionale.', 14, y)
                    y+=6
                    doc.text('La formula "Full Access" comprende l\'accesso illimitato ai calendari d\'esame di tutte le sedi di esame dell\'Ateneo.', 14, y);
                    y+=3
                    doc.text('La formula "Full Access Plus" comprende, in aggiunta alle caratteristiche di Full Access, la possibilità di sostenere le prove intermedie anche il sabato.', 14, y);
                    y+=3
                    doc.text('La formula "Base" non include i vantaggi sopra elencati e limita l\'accesso al calendario di esami della sede "statutaria".', 14, y);
                    y+=6
                    doc.text('Le condizioni complete di Agevolazioni e Programmi sono consultabili sui siti istituzionali degli Atenei di riferimento.', 14, y)
                    y+=15
                });

                doc.setFontSize(12);
                doc.setTextColor(0);
                doc.text("NOTA:", 14, y);
                y+=5
                doc.setFontSize(8);
                doc.setTextColor(100);
                doc.text('Nessuno dei dati e/o delle informazioni contenute nel presente documento hanno carattere vincolate e/o contrattuale e/o natura precontrattuale', 14, y)
                y+=3
                doc.text('tra le Parti. Le informazioni e i dati contenuti hanno carattere meramente esemplificativo di mera simulazione di eventuali costi da sostenere per', 14, y)
                y+=3
                doc.text('il pagamento della retta universitaria.', 14, y)

                // 7. Salva il PDF
                const name_slug = this.name ? 'prospetto-retta-' + this.name.replace(/\s+/g, '-').toLowerCase() : 'prospetto-retta';
                doc.save(name_slug + ".pdf");
            }
        }
    }
</script>

<style scoped>
    .border-primary {
        border-color:#a71d23 !important;
    }
    .btn-outline-primary {
        border-color:#a71d23 !important;
        color:#a71d23 !important;
    }
    .btn-outline-primary:hover {
        color: #fff!important;
        background-color: #a71d23 !important;
    }
    .btn-primary {
        color: #fff!important;
        background-color: #a71d23 !important;
        border-color:#a71d23 !important;
    }
    .border-top-pricing {
        border-top: 2px solid #a71d23 !important;
        border-right: 2px solid #a71d23 !important;
        border-left: 2px solid #a71d23 !important;
    }
    .border-bottom-pricing {
        border-bottom: 2px solid #a71d23 !important;
        border-right: 2px solid #a71d23 !important;
        border-left: 2px solid #a71d23 !important;
    }
    .border-x-pricing {
        border-right: 2px solid #a71d23 !important;
        border-left: 2px solid #a71d23 !important;
    }
</style>